export default function VendorTag({ name, type }) {
  const isCod = type === 'cod' || type === 'COD';
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-semibold ${
        isCod ? 'bg-amber-50 text-amber-700' : 'bg-indigo-50 text-indigo-700'
      }`}
    >
      {name || 'Unknown'}
      {type && <span className="ml-1 opacity-70">({isCod ? 'COD' : 'Statement'})</span>}
    </span>
  );
}
